import { createAuthInterceptor } from './authInterceptor';
import { baseURL } from 'app/client';

export const createApiConfig = (ConfigClass: any) => {
  return new ConfigClass({
    basePath: baseURL,
    fetchApi: createAuthInterceptor()
  });
};
